import { IApiService } from 'src/services/IApiService';
import Sleva from '../models/Sleva';
import Trasa from '../models/Trasa';
import Cenik from 'src/models/Cenik';

export default class CiselnikyStore {
    public slevy: Sleva[];
    public trasy: Trasa[];
    public cenik: Cenik[];

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public loadAll() {
        this.slevy = [];
        this.trasy = [];
        this.cenik = [];
        return new Promise(resolve => {
            let slevyNacteny: boolean = false;
            let trasyNacteny: boolean = false;
            let cenikNacten: boolean = false;

            this.api.getCiselnikSleva()
                .then(a => {
                    a.map(sleva => {
                        this.slevy.push(sleva);
                    })
                    slevyNacteny = true;
                    if(slevyNacteny && trasyNacteny && cenikNacten) {
                        resolve(true);
                    }
                });

            this.api.getCiselnikTrasa()
                .then(a => {
                    a.map(trasa => {
                        this.trasy.push(trasa);
                    })
                    trasyNacteny = true;
                    if(slevyNacteny && trasyNacteny && cenikNacten) {
                        resolve(true);
                    }
                });
            
            this.api.getCiselnikCenik()
                .then(a => {
                    a.map(cenik => {
                        this.cenik.push(cenik);
                    })
                    cenikNacten = true;
                    if(slevyNacteny && trasyNacteny && cenikNacten) {
                        resolve(true);
                    }
                });
        });
    }

    public getLatestValidProgramByValue(programValue: number): Cenik {
        let latest: Cenik = null;
        this.cenik.forEach(val => {
            if(val.valid === true && val.value === programValue) {
                if(latest === null || latest === undefined) {
                    latest = val;
                } else if(val.id > latest.id) {
                    latest = val;
                }
            }
        })
        return latest;
    }

    public getProgramByID(id: number): Cenik {
        return this.cenik.find((value: Cenik) => {
            return (value.id === id);
        });
    }

    public getAllValidPrograms(): Cenik[] {
        return this.cenik.filter((value: Cenik) => {
            return value.valid;
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/CiselnikyStore.tsx